import React from 'react';
import { SiteNav } from './components/SiteNav';
import { Hero } from './components/Hero';
import { Gallery } from './components/Gallery';
import { LoyaltyApp } from './components/LoyaltyApp';
import { Products } from './components/Products';
import { Signature } from './components/Signature';
import { Craft } from './components/Craft';
import { Reviews } from './components/Reviews';
import { Visit } from './components/Visit';
import { SiteFooter } from './components/SiteFooter';
interface AppProps {
  heroMedia?: 'video' | 'image';
  showReviews?: boolean;
}
export function App({
  heroMedia = 'video',
  showReviews = true
}: AppProps) {
  return <div className="w-full bg-cream" data-id="element-0" data-mp="31c1ha9rvpqf7">
      <SiteNav data-id="element-1" data-mp="2wka1mua9h53u" />
      <main data-id="element-2" data-mp="2wjqhr811w6n6">
        <Hero media={heroMedia} data-id="element-3" data-mp="2wiyvintcfl9k" />
        <Gallery data-id="element-4" data-mp="2whx9xpepbgdl" />
        <LoyaltyApp data-id="element-5" data-mp="28ufp6dtutik4" />
        <Products data-id="element-6" data-mp="28tw4wqgqei2x" />
        <Signature data-id="element-7" data-mp="28te2fc3h77mk" />
        <Craft data-id="element-8" data-mp="28suv0pbgc1ms" />
        {showReviews && <Reviews data-id="element-9" data-mp="23vcjcr61v8b3" />}
        <Visit data-id="element-10" data-mp="23vune9yyeqtk" />
      </main>
      <SiteFooter data-id="element-11" data-mp="23ujk0b9f7l2z" />
    </div>;
}